import { render, staticRenderFns } from "./LoyaltyDetails.vue?vue&type=template&id=05b4fa54&scoped=true"
import script from "./LoyaltyDetails.vue?vue&type=script&lang=js"
export * from "./LoyaltyDetails.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyDetails.vue?vue&type=style&index=0&id=05b4fa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4fa54",
  null
  
)

export default component.exports